import { Flex } from '@everlywell/ui-kit';
import InputField from 'components/FormFields/InputField';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import {
  restrictCharacterLength,
  restrictNumericInputEvent,
} from 'utils/formHelpers';

export type WeightDataFormProps = {};

export type PrePurchaseQuizWeightData = {
  weight: number;
  heightFeet: number;
  heightInches: number;
};

type ValidateKeyDownParams = {
  event: React.KeyboardEvent<HTMLInputElement>;
  limit: number;
  allowZeroAtStart?: boolean;
};

/**
 * This component adds the weight data form fields to the pre-purchase quiz modal.
 */
function WeightDataForm(props: WeightDataFormProps): JSX.Element {
  const { register } = useFormContext();
  // TODO: move content to contentful and fetch it from there

  const validateKeyDown = ({
    event,
    limit,
    allowZeroAtStart,
  }: ValidateKeyDownParams) => {
    restrictNumericInputEvent(event, allowZeroAtStart);
    restrictCharacterLength(event, limit);
  };

  return (
    <Flex flexDirection="column" gap={3} marginTop={[4, 6]}>
      <Flex flexDirection={['column', null, 'row']} gap={4}>
        <InputField
          ref={register}
          label="Your weight (lbs)"
          placeholder="190"
          name="weight"
          validations={{
            required: 'Weight is a required field',
          }}
          onKeyDown={(event) => validateKeyDown({ event, limit: 4 })}
        />
      </Flex>
      <Flex flexDirection={['column', null, 'row']} gap={4}>
        <InputField
          ref={register}
          label="Your height (ft)"
          placeholder="5"
          name="heightFeet"
          validations={{
            required: 'Height is a required field',
          }}
          onKeyDown={(event) => validateKeyDown({ event, limit: 1 })}
        />
        <InputField
          ref={register}
          label="Inches"
          placeholder="6"
          name="heightInches"
          validations={{
            required: 'Height is a required field',
          }}
          onKeyDown={(event) =>
            validateKeyDown({ event, limit: 2, allowZeroAtStart: true })
          }
        />
      </Flex>
    </Flex>
  );
}

export default WeightDataForm;
